import { toast } from "react-toastify";

export const populateTemplate = async (
  file: File,
  templateId: string,
  token: string,
  refresh: () => void,
  onHide: () => void,
  setfileuploading: (val: boolean) => void
): Promise<void> => {
  try {
    setfileuploading(true);

    const formData = new FormData();
    formData.append("spreadsheet_file", file);
    formData.append("template_id", templateId);

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URI}/mdm/engagement-letter/spreadsheet_file_details/`,
      {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = await response.json();

    if (data.success === true) {
      toast.success("File Initialized successfully!", {
        position: "bottom-right",
        autoClose: 2500,
        className: "toastify-color-success",
      });
      refresh();
      onHide();
    } else {
      toast.error("File Initialization Failed: " + data.message, {
        position: "bottom-right",
        autoClose: 3500,
        className: "toastify-color-error",
      });
      onHide();
    }
  } catch (error) {
    console.error("Error:", error);
  } finally {
    setfileuploading(false);
  }
};
